import React from 'react';
import { Icon } from '@chakra-ui/react';

export const IconClose = (props) => (
  <Icon fill="currentColor" {...props}>
    <g clipPath="url(#clip0)">
      <rect width="30" height="30" fill="white" />
      <path
        d="M5.10049 4.89954L24.8995 24.6985"
        stroke="black"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.8995 4.89954L5.10049 24.6985"
        stroke="black"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="30" height="30" fill="white" />
      </clipPath>
    </defs>
  </Icon>
);
